export function getTypesForPostQuery(postType) {
  if (postType === 'story') {
    return ['story'];
  }
  if (postType === 'recipe') {
    return ['recipe'];
  }
  return ['cas', 'gallery', 'graphic', 'homepage', 'page', 'post', 'quiz', 'sponsored_article'];
}
